export const SET_AUTH_DATA = "SET_AUTH_DATA";
export const AUTH_RESET = "AUTH_RESET";
